module.exports = __webpack_public_path__ + "img/accessory_hat_07.ca8403d3.svg";